import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styletron-react';
import { getDotBackgroundColor, getDotSize, } from './dotConst';
const StyledDot = styled('div', (p) => ({
    height: p.$height,
    width: p.$width,
    borderRadius: '50%',
    backgroundColor: p.$backgroundColor,
}));
export const Dot = ({ color = 'grey', size = 'small' }) => {
    const dotBackgroundColor = getDotBackgroundColor(color);
    const { height, width } = getDotSize(size);
    return (_jsx(StyledDot, { $backgroundColor: dotBackgroundColor, $height: height, $width: width }));
};
